<script setup lang="ts">
import { CircleCheckBig } from 'lucide-vue-next'

defineProps<{}>()
</script>

<template>
  <div
    class="flex flex-col gap-2 w-full items-center px-2 h-full justify-center overflow-hidden min-h-96"
  >
    <CircleCheckBig class="w-20 h-20 text-green-500" stroke-width="1.5" />
    <h2 class="text-lg font-semibold">Betalingen er fullført!</h2>
    <div class="text-sm text-slate-500 w-full">
      <p>
        Betalingen er bekreftet. Takk for at du handler hos oss! Du vil motta en kvittering på
        e-post. Du kan nå lukke dette vinduet.
      </p>
    </div>
  </div>
</template>
